export default "__VITE_ASSET__88641f50__"